import React from "react";
import Sponser from "../../components/home/Sponser";
import HeroSection from "../../components/home/HeroSection";
import ProximityDetectionSection from "../../components/home/ProximitySection";
import SupportingSection from "../../components/home/SupportingSection";
import EmpowerSection from "../../components/home/EmpowerSection";
import Defence from "../../components/home/Defence";
import ReviewsSection from "../../components/home/ReviewsSection";
import ContactSection from "../../components/home/ContactSection";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <Sponser />
      <ProximityDetectionSection />
      <SupportingSection />
      <EmpowerSection />
      {/* <Defence /> */}
      {/* <ReviewsSection /> */}
      <ContactSection />
    </div>
  );
};

export default Home;
